<template>
  <v-card
    shaped
    color="#CFD8DC"
  >
    <br>
    <v-col
      cols="12"
      class="text-right"
    >
      <v-btn
        color="#FF3700"
        @click="createPermission()"
      >
        <v-icon
          left
          dark
        >
          mdi-plus
        </v-icon>
        Permissions
      </v-btn>
    </v-col>
    <v-card-title>
      <v-row>
        <v-col
          cols="12"
          lg="4"
        >
          <v-text-field
            v-model="search"
            label="Search"
            append-icon="mdi-magnify"
            outlined
            dense
          />
        </v-col>
      </v-row>
    </v-card-title>
    <v-toolbar
      flat
      color="#ECEFF1"
    >
      <v-toolbar-title class="my-toolbar-style">
        Permissions List
      </v-toolbar-title>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="permissionsList"
      :search="search"
      class="elevation-1"
    >
      <template
        #item="{ item }"
      >
        <tr>
          <td>
            {{ item.name }}
          </td>
          <td>
            {{ item.category }}
          </td>
          <td>
            {{ item.description }}
          </td>
        </tr>
      </template>
    </v-data-table>
    <div class="py-3" />
    <centre-spinner
      :loading="loading"
    />
    <create-permission
      v-if="showCreatePermissionDialog"
      @closed="showCreatePermissionDialog=false"
    />
  </v-card>
</template>

<script>
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import CreatePermission from 'src/views/dashboard/settings/CreatePermission.vue';
  export default {
    name: 'PermissionsList',
    components: {
      'centre-spinner': spinner,
      'create-permission': CreatePermission,
    },
    data () {
      return {
        search: '',
        loading: false,
        headers: [
          { text: 'Permissions', align: 'start', value: 'name' },
          { text: 'Category', value: 'category' },
          { text: 'Description', value: 'description' },
        ],
        showCreatePermissionDialog: false,
      };
    },
    computed: {
      permissionsList () {
        return this.$store.getters['accountcontrol/getPermissionList'];
      },
    },
    mounted () {
      this.getPermissionsList();
    },
    methods: {
      async getPermissionsList () {
        this.loading = true;
        await this.$store.dispatch('accountcontrol/fetchPermissionsList');
        this.loading = false;
      },
      createPermission () {
        this.showCreatePermissionDialog = true;
      },
    },
  };
</script>
<style scoped>
.v-data-table::v-deep th {
  font-size: 12px !important;
  color: #37474F !important;
  font-weight: bold !important;
}
.v-data-table::v-deep td {
  font-size: 13px !important;
  color: #37474F !important;
}
.theme--light.v-data-table tbody tr:nth-of-type(even) {
  background-color: #CFD8DC
}
.font-my-style {
  font-weight: bold;
}
.v-data-table { background-color: #ECEFF1; }
.title-style {
  color: #37474F;
}
.my-toolbar-style {
  color: #37474F;
  font-weight: bold;
}
</style>
